import { createContext, useContext } from 'react'

type CutOffRowDateTimeContextType = {
  date: string
  time: string
}

const CutOffRowDateTimeContext = createContext<CutOffRowDateTimeContextType | null>(null)

export const useCutOffDateTimeContext = (): CutOffRowDateTimeContextType => {
  const context = useContext(CutOffRowDateTimeContext)

  if (!context) {
    throw new Error('useCutOffDateTimeContext must be used within a CutOffRowDateTimeProvider')
  }

  return context
}

export const CutOffRowDateTimeProvider = ({ children, date, time }: { children: React.ReactNode; date: string; time: string }) => {
  return <CutOffRowDateTimeContext.Provider value={{ date, time }}>{children}</CutOffRowDateTimeContext.Provider>
}
